'use client';

import { useEffect, useState } from 'react';
import { IEconomyData } from '../types/interfaces';

type EconomyResponse =
  | {
      ok: true;
      data: {
        nextCycleResetAtUtc: string;
        cycleLengthDays: number;
        level2ThresholdXp: number;
        level3ThresholdXp: number;
        maxCycleLevel: number;
        giveSuperlikesPerDay: number;
      };
    }
  | {
      ok: false;
      error: string;
    };

export function useCycleResetTime() {
  const [targetIso, setTargetIso] = useState<string | null>(null);
  const [economyData, setEconomyData] = useState<IEconomyData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const res = await fetch('/api/economy');
        const json: EconomyResponse = await res.json();

        if (!cancelled && json.ok) {
          setTargetIso(json.data.nextCycleResetAtUtc);
          setEconomyData({
            cycleLengthDays: json.data.cycleLengthDays,
            level2ThresholdXp: json.data.level2ThresholdXp,
            level3ThresholdXp: json.data.level3ThresholdXp,
            maxCycleLevel: json.data.maxCycleLevel,
            giveSuperlikesPerDay: json.data.giveSuperlikesPerDay,
          });
        }
      } catch (e) {
        console.error('Failed to load economy time', e);
        if (!cancelled) {
          setTargetIso(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { economyData, targetIso, loading };
}
